<script setup>
import { USER_ACCOUNT_STATUS_TO_READABLE, UserAccountStatus } from '@pfsc/core/models/user-account-status';
import { lookupService } from '@pfsc/core/services/lookup.service';
import { globalTranslate } from '@pfsc/shared/locale/app.i18n';
import { onMounted, ref } from 'vue';

defineProps({
  modelValue: {
    type: UserAccountStatus,
    required: false,
  },
});

const emits = defineEmits(['update:model-value']);

const items = ref([]);

onMounted(async () => {
  items.value = await lookupService.getUserAccountStatuses();
});

const STATUS_TO_READABLE = {
  ...USER_ACCOUNT_STATUS_TO_READABLE,
  All: globalTranslate('userStatus.all'),
};

/**
 * To readable status.
 * @param {object} status User status.
 * @returns {string}
 */
function toReadableStatus(status) {
  return STATUS_TO_READABLE[status.name];
}

</script>
<template>
  <v-select
    :model-value="modelValue"
    :items="items"
    :item-title="toReadableStatus"
    return-object
    hide-details
    @update:model-value="emits('update:model-value', $event)"
  />
</template>
